import React, {useState, useEffect} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styles from "../../css/PreferredJobs.module.css";
const PreferredJobs = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [company, setCompany] = useState("");
    const [jobs, setJobs] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);    
    const [location, setLocation] = useState("");
    const [requirements, setRequirements] = useState("");
    const [jobType, setJobType] = useState("");
    const [sortField, setSortField] = useState("createdAt"); // Default sorting field
    const [sortOrder, setSortOrder] = useState("desc"); // Default sorting order
    const [resume, setResume] = useState(null); // State for resume file
    const [coverLetter, setCoverLetter] = useState(''); // State for cover letter text
    const { id } = useParams(); // Access job ID from the URL
    const [successMessage, setSuccessMessage] = useState('');

    
    const navigate = useNavigate();
    
    useEffect(() => {
        fetchPreferredJobs();
      }, []);

    const fetchPreferredJobs = async () => {
      try {
        setLoading(true);
        setError("");

        const token = localStorage.getItem("token");
        const queryParams = new URLSearchParams();
        const response = await axios.get(
          `https://techservicemarket-backend.onrender.com/api/users/jobs?${queryParams.toString()}`,
          {
            headers: {
            Authorization: `Bearer ${token}`,
            },
          }
        );
        
        // setJobs(response.data.filter((job) => job.preferredId));
        setJobs(response.data);

      } catch (error) {
        console.error("Error fetching preferred jobs:", error);
        setError("Failed to fetch preferred jobs. Please try again.");
      } finally {
        setLoading(false);
      }

    };

    const highlightSkills = (jobSkills = []) => {
        const skillList = requirements
          ? requirements
              .split(",")
              .map((skill) => skill.trim().toLowerCase())
              .filter((skill) => skill !== "")
          : [];
          return jobSkills.map((skill) => {
            const isExactMatch = skillList.includes(skill.toLowerCase());
            return (
              <span key={skill} className={isExactMatch ? styles.highlight : ""}>
                {skill} {skill !== skillList[skillList.length - 1]}
              </span>
            );
          });
        };
  // Handle resume file upload
  const handleResumeUpload = (e) => {
    const resumeFile = e.target.files[0];
    setResume(resumeFile);
  };
  const handleSearch = async () => {
    try {
      setLoading(true);
      setError("");
      const queryParams = new URLSearchParams();
      if (searchTerm) queryParams.append("title", searchTerm);
      if (company) queryParams.append("company", company);
      if (location) queryParams.append("location", location);
      if (requirements) queryParams.append("requirements", requirements);
      if (jobType) queryParams.append("jobType", jobType);
      if (sortField) queryParams.append("sortField", sortField);
      if (sortOrder) queryParams.append("sortOrder", sortOrder);
  
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://techservicemarket-backend.onrender.com/api/users/jobs?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setJobs(response.data); // Updated list will exclude reposted jobs
    } catch (error) {
      console.error("Error fetching jobs:", error);
      setError("An error occurred while fetching jobs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSortChange = (field) => {
    // Toggle sort order if the same field is selected, otherwise reset to ascending
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };
      // Handle cover letter input change
  const handleCoverLetterChange = (e) => {
    setCoverLetter(e.target.value);
  };
      // Handle application submission
  const handleApply = async (job_id) => {
    try {
      console.log(`Token is ${localStorage.getItem('token')}`)
      // Upload resume if there is one
      if (resume) {
        const formData = new FormData();
        formData.append("resume-upload", resume); 
        await axios.post(
          "https://techservicemarket-backend.onrender.com/api/users/profile/resume",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
      }
  
      // Apply for the job with cover letter as JSON
      const response = await axios.post(
        `https://techservicemarket-backend.onrender.com/api/users/jobs/${job_id}/apply`,
        { coverLetter },  // Send cover letter as JSON
        {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      
      alert("Application submitted successfully");
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong!');
      setSuccessMessage('');
    }
    
  };
    return (
        <div className={styles.dashboardContainer}>
          <h1 className={styles.dashboardHeader}>Preferred Jobs</h1>
          <div className={styles.contentContainer}>
        {/* Search Section */}
        <div className={styles.searchSection}>
            <div className={styles.column1}>
            <input
            type="text"
            placeholder="Search by Title"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Search by Company"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Search by Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Search by Requirements (comma separated)"
            value={requirements}
            onChange={(e) => setRequirements(e.target.value)}
            className={styles.searchInput}
          />
          <select
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
            className={styles.selectInput}
          >
            <option value="">Select Job Type</option>
            <option value="Full-time">Full-time</option>
            <option value="Part-time">Part-time</option>
            <option value="Contract">Contract</option>
            <option value="Internship">Internship</option>
          </select>
          <button onClick={handleSearch} className={styles.searchButton}>
            Search
          </button>
            </div>
            <div className={styles.column2}>
              {/* Upload Resume Button */}
              <label htmlFor="resume-upload" className={styles.uploadButton}>
            Upload Resume
          </label>
          <input
            type="file"
            id="resume-upload"
            onChange={handleResumeUpload}
            style={{ display: "none" }}
          />
          <label htmlFor="coverLetter">
            Cover Letter (Optional)
          </label>
          <textarea
            id="coverLetter"
            value={coverLetter}
            onChange={handleCoverLetterChange}
            placeholder="Write your cover letter here..."
            className={styles.coverLetterTextarea}
          ></textarea>
            </div>
        </div>

        {/* Sorting Options and Navigate Button */}
        <div className={styles.sortSection} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <button
              onClick={() => handleSortChange("salary")}
              className={styles.sortButton}
            >
              Sort by Salary{" "}
              {sortField === "salary" &&
                (sortOrder === "asc" ? "(less)" : "(more)")}
            </button>
            <button
              onClick={() => handleSortChange("requirements")}
              className={styles.sortButton}
            >
              Sort by Requirements{" "}
              {sortField === "requirements" &&
                (sortOrder === "asc" ? "(less)" : "(more)")}
            </button>
            <button
              onClick={() => handleSortChange("createdAt")}
              className={styles.sortButton}
            >
              Sort by Date Posted{" "}
              {sortField === "createdAt" &&
                (sortOrder === "asc" ? "(old to new)" : "(new to old)")}
            </button>
        </div>
        {       /* Job List Section */}
        <div className={styles.jobListSection}>
            {loading && <p>Loading jobs...</p>}

        {!loading && error && <p className={styles.errorText}>{error}</p>}

        {!loading && !error && jobs.length === 0 && (
        <p>No jobs found. Try adjusting your search criteria.</p>
        )}

        {!loading && !error && jobs.length > 0 && (
        jobs.map((job) => (
            <div className={styles.jobCardLink}>
              <div className={styles.jobCard}>
                <h3>{job.title}</h3>
                <p>
                <strong>Company:</strong> {job.company || "Unknown"}
                </p>
                <p>
                <strong>Location:</strong> {job.location || "Not specified"}
                </p>
                <p>
                <strong>Salary:</strong>{" "}
                {job.salary ? `$${job.salary}` : "Not specified"}
                </p>
                <p>
                <strong>Job Type:</strong> {job.jobType || "Not specified"}
                </p>
                <p>
                <strong>Skills Required:</strong>{" "}
                {highlightSkills(job.requirements || [])}
                </p>
                <p><strong>Description:</strong> </p>
                <p className={styles.pScroll}>
                    {job.description}</p>
                <p>
                <strong>Date Posted:</strong>{" "}
                {new Date(job.createdAt).toLocaleDateString()}
                </p>

                <button type="button" onClick={() => handleApply(job._id)} className={styles.submitButton}>Send Application</button>               
              </div>
            </div>
            
        ))
        )}
        </div>
        <div className={styles.footer}>
        <footer>
          <p>&copy;2024 TechServiceMarket Software</p>
        </footer>
      </div>
    </div>
    </div>
    );
};

export default PreferredJobs;